import React, {useState} from 'react'

const ImageUpload = ({setter}) => {
  const [Image,setImage]=useState("");
  const [display,setDisplay]=useState();
  
    const submitImage=async()=>{
      if(Image==="" || Image===null){
        alert("Insert an image");
        return;
      };
      const data = new FormData();
      data.append("file",Image);
      data.append("upload_preset","custoshoe7")
      data.append("cloud_name","custoshoe7");
  
      await fetch(`${process.env.REACT_APP_CLOUDINARY_URL}`,
      {
        method:"POST",
        body:data
      })
      .then((res)=>res.json())
      .then((data)=>{
        setter(data.url);
        document.getElementById("uploadCaptureInputFile").value = "";
        setImage("");
      }).catch((err)=>{
        console.error('Error:', err);
      })
    }
    return (
     <>
      <div>
        <div className='grid grid-cols-2'>
          <input type="file" id="uploadCaptureInputFile" accept="image/*" onChange={(e)=>{setImage(e.target.files[0])}}/>
          <div className='flex justify-center center content-evenly'>
          <div className=" w-3/4 bg-green-500 rounded-full px-3 py-1 text-sm font-semibold text-white mr-2 mb-2 hover:bg-green-700 cursor:pointer" onClick={submitImage}>Upload</div>
          </div>
        </div>
      </div>
     </>
    );
}

export default ImageUpload